'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var styles = require('@material-ui/core/styles');
var IconButton = require('@material-ui/core/IconButton');
var CheckIcon = require('@material-ui/icons/Check');
require('../ThemeProvider/ThemeProvider.js');
var colors = require('../ThemeProvider/colors.js');
require('../ThemeProvider/theme.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var IconButton__default = /*#__PURE__*/_interopDefaultLegacy(IconButton);
var CheckIcon__default = /*#__PURE__*/_interopDefaultLegacy(CheckIcon);

/**
 * Button for selecting the picker color.
 */

function ColorPickerButton(_ref) {
  var {
    checked,
    color = colors.colors.blueGrey[500],
    onClick
  } = _ref;
  var theme = styles.useTheme();
  return /*#__PURE__*/React__default['default'].createElement(IconButton__default['default'], {
    onClick: onClick,
    sx: {
      backgroundColor: color,
      color: theme.palette.white,
      margin: theme.spacing(0.5),
      minWidth: 22,
      minHeight: 22,
      '&:hover': {
        backgroundColor: styles.alpha(color || '#fff', 0.5)
      }
    }
  }, checked && /*#__PURE__*/React__default['default'].createElement(CheckIcon__default['default'], null));
}
ColorPickerButton.propTypes = {
  /** If `true`, a check mark appears. */
  checked: index.bool,

  /** Color of the button. */
  color: index.string,

  /** Label of the button. */
  label: index.string,

  /**
   * Callback when button is clicked.
   */
  onClick: index.func
};

exports.ColorPickerButton = ColorPickerButton;
